import { ApplyCard } from './ApplySection'
import { FollowUsContent } from './FollowUsSection'

export function JoinAndFollowSection() {
  return (
    <section className="py-24">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 md:items-stretch">
          <ApplyCard />
          <FollowUsContent />
        </div>
      </div>
    </section>
  )
}
